import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=78c31c22&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=ts"
export * from "./BaseModal.vue?vue&type=script&lang=ts"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=78c31c22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c31c22",
  null
  
)

export default component.exports